import { render, staticRenderFns } from "./change-preview-type.vue?vue&type=template&id=19a33c2e&scoped=true&"
import script from "./change-preview-type.vue?vue&type=script&lang=ts&"
export * from "./change-preview-type.vue?vue&type=script&lang=ts&"
import style0 from "./change-preview-type.vue?vue&type=style&index=0&id=19a33c2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a33c2e",
  null
  
)

export default component.exports